module.exports = __webpack_public_path__ + "static/media/TUNE_4336.9721476d.jpg";